import { IconProps } from './interfaces';

export const SearchIcon = ({ className }: IconProps) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m11 2c-4.6944 0-8.5 3.8056-8.5 8.5 0 4.6944 3.8056 8.5 8.5 8.5 1.8587 0 3.5781-0.5966 4.9771-1.6087l3.8612 3.8612c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142l-3.8023-3.8023c1.2777-1.4873 2.0498-3.4215 2.0498-5.536 0-4.6944-3.8056-8.5-8.5-8.5zm-6.5 8.5c0-3.5898 2.9102-6.5 6.5-6.5 3.5899 0 6.5 2.9102 6.5 6.5 0 3.5899-2.9101 6.5-6.5 6.5-3.5898 0-6.5-2.9101-6.5-6.5z"
                clipRule="evenodd"
                fillRule="evenodd"
            />
        </svg>
    );
};
